const projects = [
    {
      title: "Frontend Tesla Clone",
      subtitle: "HTML, CSS, JavaScript, TailwindCSS, NPM",
      description:
        "I am a fan of Tesla, so i decided to learn TailwindCSS and replicate their homepage. Note: it might differ from theirs later on",
      image: "./images/tesla.png",
      link: "https://tesla-clone-tailwindcss.netlify.app/",
    },
    {
      title: "Moglad Caterers",
      subtitle: "CSS, JavaScript, Payment API Integration, MySQL",
      description:
        "Project to allow Customers place an order by booking. Payment was Integrated through Stripe API with JavaScript",
      image: "./images/moglad.png",
      link: "https://mogladcaterers.com/",
    },
    {
      title: "Restaurant Website",
      subtitle: "HTML5, CSS3, JavaScript",
      description:
        "A simple Restaurant website to showcase your  info. It is also customizable to fit your business ",
      image: "./images/restaurant.png",
      link: "https://philip-restaurant-web-app.netlify.app/",
    },
    {
      title: "Authentication Web app",
      subtitle: "TailwindCSS, JavaScript, Node.Js, MongoDB, Express.js",
      description:
        "A Web application to register users, log in users by authenticating them and authorizing users on different routes ",
      image: "./images/auth.png",
      link: "",
    },

    
];

const skills = ["TailwindCSS", "JavaScript", "Node.js", "React", "MySQL", "MongoDB"];

const testimonials = [
  {
    quote: "Philip is a humble and patient Mentor, who takes teaching and guidance passionately. He is the kind of person you can work with and get things done without fretting.",
    image: "./images/bolaji.jpeg",
    name:  "BAKARE AHMED",
    occupation: "Student",
  },
  {
    quote: "Philip is one of the most professional and capable person I have worked with as a graphic designer, and I have worked with many! You can expect quality and accessible web applications delivered on deadline and a smooth communication process. I recommend his services thoroughly.",
    image: "./images/godbless.jpg",
    name:  "ALALI GODBLESS",
    occupation: "Graphics Designer",
  }
];

export {projects, skills, testimonials };

